export const fieldTypeLabels = {
  text: 'Kısa metin',
  textarea: 'Uzun metin',
  number: 'Sayı',
  date: 'Tarih',
  select: 'Seçim listesi',
  radio: 'Tekli seçim (radyo)',
  multiselect: 'Çoklu seçim (onay kutuları)',
  imageChoiceSingle: 'Görsel seçim (tekli)',
  imageChoiceMulti: 'Görsel seçim (çoklu)',
  checkbox: 'Onay kutusu',
  file: 'Dosya',
  photo: 'Fotoğraf',
  video: 'Video',
};

export const fieldTypeOptions = Object.entries(fieldTypeLabels).map(([value, label]) => ({ value, label }));

export function fieldTypeLabel(value) {
  return fieldTypeLabels[value] || value;
}

export function uploadAccept(field) {
  if (field.allowedExtensions) {
    return field.allowedExtensions;
  }

  if (field.fieldType === 'photo') {
    return 'image/*';
  }

  if (field.fieldType === 'video') {
    return 'video/*';
  }

  return undefined;
}